export const FR: Record<string, string> = {
  "Home": "Accueil",
      "Resource Selected": "Ressource sélectionnée",
      "Resources List": "Liste des ressources",
      "List": "Liste",
      "Resources": "Ressources",
      "Find Colleague": "Trouver un collègue",
      "Settings": "Paramètres",
      "Floor Plan": "Plan d'étage",
      "Locations": "Emplacements",
      "Categories": "Catégories",
      "Search resource name...": "Rechercher un nom de ressource...",
      "Calendar": "Calendrier",
      "View Details": "Voir les détails",
      "Add to My Favorites": "Ajouter à mes favoris",
      "Remove": "Supprimer",
      "Resource calendar": "Calendrier de la ressource",
      "Today": "Aujourd'hui",
      "Previous month": "Mois précédent",
      "Next month": "Mois suivant",
      "Previous year": "Année précédente",
      "Next year": "Année suivante",
      "Close": "Fermer",
      "Field is required.": "Champ requis.",
      "Invalid date format.": "Format de date invalide.",
      "S": "Dim",
      "M": "Lun",
      "T": "Mar",
      "W": "Mer",
      "F": "Ven",
      "January": "Janvier",
      "February": "Février",
      "March": "Mars",
      "April": "Avril",
      "May": "Mai",
      "June": "Juin",
      "July": "Juillet",
      "August": "Août",
      "September": "Septembre",
      "October": "Octobre",
      "November": "Novembre",
      "December": "Décembre",
      "Jan": "Jan",
      "Feb": "Fév",
      "Mar": "Mar",
      "Apr": "Avr",
      "Jun": "Juin",
      "Jul": "Juil",
      "Aug": "Août",
      "Sep": "Sep",
      "Oct": "Oct",
      "Nov": "Nov",
      "Dec": "Déc",
      "st": "",
      "nd": "",
      "rd": "",
      "th": "",
      "Sunday": "Dimanche",
      "Monday": "Lundi",
      "Tuesday": "Mardi",
      "Wednesday": "Mercredi",
      "Thursday": "Jeudi",
      "Friday": "Vendredi",
      "Saturday": "Samedi",
      "Sun": "Dim",
      "Mon": "Lun",
      "Tue": "Mar",
      "Wed": "Mer",
      "Thu": "Jeu",
      "Fri": "Ven",
      "Sat": "Sam",
      "Su": "Di",
      "Mo": "Lu",
      "Tu": "Ma",
      "We": "Me",
      "Th": "Je",
      "Fr": "Ve",
      "Sa": "Sa",
      "PM": "PM",
      "AM": "AM",
      "You cannot book this resource because your meeting request conflicts with the resource's booking policies.": "Vous ne pouvez pas réserver cette ressource car votre demande de réunion est en conflit avec les politiques de réservation de la ressource.",
      "You need permissions to interact with this resource.": "Vous avez besoin d'autorisations pour interagir avec cette ressource.",
      "Reason": "Raison",
      "The resource cannot be booked {{day}} days in advanced.": "La ressource ne peut pas être réservée {{day}} jours à l'avance.",
      "The end date of a recurring meeting cannot be more than {{day}} days from today.": "La date de fin d'une réunion récurrente ne peut pas être supérieure à {{day}} jours à partir d'aujourd'hui.",
      "Meeting duration cannot be longer than {{time}} minutes long.": "La durée de la réunion ne peut pas dépasser {{time}} minutes.",
      "Meeting duration cannot be shorter than {{time}} minutes long.": "La durée de la réunion ne peut pas être inférieure à {{time}} minutes.",
      "Booking policy": "Politique de réservation",
      "Available": "Disponible",
      "Selected": "Sélectionné",
      "Booked": "Réservé",
      "Closed": "Fermé",
      "Filter Options": "Options de filtre",
      "{{resource}} is deleted": "{{resource}} est supprimé.",
      "This resource can be booked but any occurrences with conflicts the resource will not be booked.": "Cette ressource peut être réservée mais toute occurrence en conflit avec la ressource ne sera pas réservée.",
      "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked": "Cette ressource peut être réservée à l'avance pour un maximum de {{day}} jours, toute occurrence au-delà de cette limite ne sera pas réservée",
      "This resource can be booked, but the meeting duration must be at least {{time}} minutes.": "Cette ressource peut être réservée, mais la durée de la réunion doit être d'au moins {{time}} minutes.",
      "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.": "Cette ressource peut être réservée, mais la durée de la réunion ne doit pas dépasser {{time}} minutes.",
      "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.": "La réservation de cette ressource nécessite l'approbation du délégué de la ressource. Votre demande sera transmise en attente d'approbation.",
      "Resource Name": "Nom de la ressource",
      "Description": "Description",
      "Resource Mail": "Mail de la ressource",
      "Location": "Emplacement",
      "Capacity": "Capacité",
      "Language": "Langue",
      "Select an language": "Sélectionnez une langue",
      "Date/Time Format": "Format date/heure",
      "First day of the week": "Premier jour de la semaine",
      "Please select a first day": "Veuillez sélectionner un premier jour",
      "Please select a time format": "Veuillez sélectionner un format d'heure",
      "Date Format": "Format de date",
      "Please select a date format": "Veuillez sélectionner un format de date",
      "Date Separator": "Séparateur de date",
      "Please select a date separator": "Veuillez sélectionner un séparateur de date",
      "Apply": "Appliquer",
      "Default Location": "Emplacement par défaut",
      "Clear": "Effacer",
      "Help": "Aide",
      "Unavailable": "Non disponible",
      "No data available": "Aucune donnée disponible",
      "More": "Plus",
      "Available Floor Plans": "Plans d'étage disponibles",
      "Default Categories": "Catégories par défaut",
      "List more Resources": "Lister plus de ressources",
      "Attendees": "Participants",
      "Click on Further information to visit our support site": "Cliquez sur Plus d'informations pour visiter notre site d'assistance",
      "New Order": "Nouvelle commande",
      "Save default categories successfully": "Enregistrer les catégories par défaut avec succès",
      "Save config date/time successfully": "Enregistrer la date/heure de configuration avec succès",
      "Save language successfully": "Enregistrer la langue avec succès",
      "Save default location successfully": "Enregistrer l'emplacement par défaut avec succès",
      "And": "Et",
  "Or": "Ou",
  "Available occurrences of the series": "Occurrences disponibles de la série",
  "Conflicting Occurrences": "Occurrences en conflit",
  "Availability": "Disponibilité",
  "Time Format": "Format de l'heure",
  "You do not have permission to book this resource.": "Vous n'avez pas la permission de réserver cette ressource.",
"This resource does not allow booking of recurring meetings.": "Cette ressource ne permet pas la réservation de réunions récurrentes.",
"You cannot book this resource.": "Vous ne pouvez pas réserver cette ressource."
};
